import React from 'react'
import CategoryTitle from '../../CategoryTitle'
import styles from './styles.module.css'
import Cta from '../../Cta'
import HighlightedText from '../../Utils/HighlightedText'
import Youtube from '../../Youtube'

function SectionTitleV2({ theme, category, titleHl, subtitleHl, textHl, leftAligned, noBottomPadding, cta, youtubeVideo }) {
  return (
    <div
      className={noBottomPadding ? `${styles.wrapper} ${styles.noBottomPadding}` : styles.wrapper}
      style={{ backgroundColor: theme.value }}
    >
      <div className={leftAligned ? `${styles.textAndCtasWrapper} ${styles.textAndCtasWrapperLeft}` : styles.textAndCtasWrapper}>
        { category && category.title && category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
        <div className={styles.title}>
          <HighlightedText {...titleHl}/>
        </div>
        <div className={styles.textBlock}>
          { subtitleHl && <div className="mb-8"><HighlightedText {...subtitleHl}/></div> }
          { textHl && <HighlightedText {...textHl}/> }
        </div>
        {
          youtubeVideo && <div className={styles.videoWrapper}>
          <Youtube url={youtubeVideo.url} height="500"/>
        </div>
        }
      </div>
      { cta && <div className={styles.ctaWrapper}><Cta fullHeight {...cta}/></div> }
    </div>
  )
}

export default SectionTitleV2
